<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template #buttons>
          <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="pendingGoodsSelectorOpts.visible = true"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('btn_add') || '新增' }}
          </b-button>
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <PendingGoodsSelector
      :visible.sync="pendingGoodsSelectorOpts.visible"
      :goodsMarker="goodsMarker"
      @confirm="pendingGoodsSelectorConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main.vue'
import PageHeader from './header'
import PendingGoodsSelector from '../pending-goods-selector'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageMain, PageHeader, PendingGoodsSelector },
  mixins: [BaseTable],
  props: { goodsMarker: { type: String, default: '' } },
  data() {
    return { usePage: true, pendingGoodsSelectorOpts: { visible: false } }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .mrpPendingGoodsInspectionListApi({
          ...form,
          ...this.page,
          goodsMarker: this.goodsMarker,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    pendingGoodsSelectorConfirm({ pendingGoodsCode } = {}) {
      if (!pendingGoodsCode) return

      this.openEditPage({ pageType: 'add', query: { pendingGoodsCode } })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$emit('openEditPage', { pageType, params, query })
    },
  },
}
</script>
